// styles
import { chartDashboardBoxStyle } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledDonutAndProgressChardCard = styled.div`
  ${chartDashboardBoxStyle}

  > h2 {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
`;

export const StyledDonutWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  margin-bottom: 28px;

  > canvas {
    position: relative;
  }
`;

export const StyledDonutLegend = styled.div`
  position: absolute;
  top: 12px;
  left: 0px;

  span {
    color: var(--color-secondary-blue);
    text-align: right;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;

    &:first-of-type {
      font-size: 36px;
    }
  }
`;

export const StyledTotalLegend = styled.div`
  position: absolute;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    color: var(--color-update-gray);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;

    &:last-of-type {
      color: var(--color-black);
      text-align: center;
      font-size: 29px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-top: -6px;
    }
  }
`;

export const StyledTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTableHeader = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr 66px 66px;
  padding-bottom: 7px;
  border-bottom: 1px solid var(--color-light-gray);
  margin-bottom: 10px;

  > p {
    text-align: center;
    color: var(--color-light-gray);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;

export const StyledTableRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-height: 185px;
  overflow-y: auto;
`;

interface StyledTableRowProps {
  $bgColor: string;
}

export const StyledTableRow = styled.div<StyledTableRowProps>`
  display: grid;
  align-items: center;
  grid-template-columns: 200px 1fr 66px 66px;

  .title {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: relative;
    padding-left: 7px;

    &::before {
      content: '';
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 14px;
      border-radius: 8px;
      background-color: ${(props) => props.$bgColor};
    }
  }

  .progress {
    position: relative;
    width: 100%;
    height: 12px;
    border-radius: 6px;
    background-color: transparent;
    overflow: hidden;
  }

  .number {
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

interface ProgressBarProps {
  $width: number;
  $backWidth: number;
  $bgColor: string;
  $subColor: string;
}

export const ProgressBar = styled.div<ProgressBarProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0 6px 6px 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 6px 6px 0;
    background-color: ${(props) => props.$bgColor};
    width: ${(props) =>
      props.$backWidth ? Math.min(Math.max((props.$width / props.$backWidth) * 100, 0), 100) : 0}%;
    height: 100%;
    z-index: 2;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 6px 6px 0;
    background-color: ${(props) => props.$subColor};
    opacity: 0.5;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`;
